var jade = require("/web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<component :is=\"panel\" v-on:continue=\"onContinue\" v-on:back=\"onBack\" trial-request-attributes=\"trialRequestAttributes\" class=\"modal-body teacher-panel\"></component>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/teacher-signup-component.jade
// module id = 862
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91